export default __webpack_public_path__ + "static/media/sd.e6347c04.svg";